import Vue from 'vue'
import {mapGetters,mapActions} from 'vuex'

import CitySelect from './city-select'

import template from './index.pug'

export default Vue.extend({
  name: 'cities-select-list-layout-custom-vl',
  template: template(),

  components: {
    CitySelect
  },

  computed: {
    ...mapGetters('municipality', ['availableMunicipalities'])
  },
  mounted(){
    
    for (let i = 0; i < this.availableMunicipalities.length; i++) {
      var id = 'municipality-' +this.availableMunicipalities[i].id
      window["variable_" + i] = document.getElementById(id);
      var left = this
      // Agregar un listener para el evento focus
      window["variable_" + i].addEventListener('focus', function() {
        var textoescuchar=left.$t('textoVoz.nombreModulo') + " " + left.availableMunicipalities[i].name_for_client
        left.escucharAudio(textoescuchar)
      });
    }

  },
  methods: {
    ...mapActions(['escucharAudio' ]),
    municipalityClass(index) {
      if (index === 0) {
        return 'end-sm'
      }
      return ''
    }
  }
})
